import React from "react";
import { WidgetContainer } from "components/shared";
import { Link } from "bcms-react";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function WirePayeeConfirmationWidget
 * @param {STRING} wirePayee - Sets the wire payee name text.
 * @param {STRING} wireAmount - Sets the wire amount text.
 * @param {STRING} wireDate -Sets the wire date text.
 * @return {React.Component}
 * @exported true
 * @description This is Wire Payee Confirmation widget for OneTimeWirePage
 */
export default function WirePayeeConfirmationWidget(props) {
    const data = props.data ?? {};
    const action = props.action ?? {};
    const createdOneTimeWireTransfer = data.createdOneTimeWireTransfer ?? {};
    const wirePayee = props.wirePayee ?? "[wirePayee]";
    const wireAmount = props.wireAmount ?? "[wireAmount]";
    const wireDate = props.wireDate ?? "[wireDate]";

    return (
        <WidgetContainer className="wire-payee-confirmation-widget">
            <div className="flex-container flex-horizontal align-center confirmation-success-container">
                <div className="flex-width flex-container align-center success-message">
                    <SVGAsset id="CircleCheckmarkIcon" className="circle-checkmark-icon" />
                    <span className="success-message-text">Wire Successfully Initiated</span>
                </div>
                <div className="set-width ">
                    <SVGAsset id="CloseX" className="close-x-icon clickable" onClick={ action.onSubmittedConfirmationClose } />
                </div>
            </div>
            <div className="confirmation-content-container">
                <p className="wire-scheduled-text">Your wire has been scheduled and is awaiting approval(s).</p>
                <div className="confirmation-info-container">
                    <div className="flex-container flex-horizontal align-center reference-number-info">
                        <div className="flex-width info-label text-center">
                            <span>Reference Number:</span>
                        </div>
                        <div className="flex-width info-text">
                            <span>{ createdOneTimeWireTransfer.referenceNumber }</span>
                        </div>
                    </div>
                    <div className="flex-container flex-horizontal align-center payee-info">
                        <div className="flex-width info-label text-center">
                            <span>Payee:</span>
                        </div>
                        <div className="flex-width info-text">
                            <span>{ createdOneTimeWireTransfer.name }</span>
                        </div>
                    </div>
                    <div className="flex-container flex-horizontal align-center amount-info">
                        <div className="flex-width info-label text-center">
                            <span>Amount:</span>
                        </div>
                        <div className="flex-width info-text">
                            <span>{ createdOneTimeWireTransfer.amount.format() }</span>
                        </div>
                    </div>
                    <div className="flex-container flex-horizontal align-center wire-date-info">
                        <div className="flex-width info-label text-center">
                            <span>Wire Date:</span>
                        </div>
                        <div className="flex-width info-text">
                            <span>{ createdOneTimeWireTransfer.date.format("m/d/Y") }</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="confirmation-link-container">
                <Link className="initiate-wire-link show-on-mobile" onClick={ action.onSubmittedConfirmationClose }>Initiate Another Wire</Link>
                <Link className="wire-activity-link show-on-desktop" to="/wiresActivity">See Wire Activity</Link>
            </div>
        </WidgetContainer>
    )
}
